const LinkedIn = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.11111 14H0.233333V4.74444H3.11111V14ZM1.67222 3.47778C0.75 3.47778 0 2.72222 0 1.80556C0 0.888889 0.75 0.133333 1.67222 0.133333C2.59444 0.133333 3.34444 0.888889 3.34444 1.80556C3.34444 2.72222 2.59444 3.47778 1.67222 3.47778ZM14 14H11.1278V9.5C11.1278 8.42778 11.1056 7.05 9.62778 7.05C8.12778 7.05 7.89444 8.22222 7.89444 9.42222V14H5.02222V4.74444H7.77778V6.01111H7.81667C8.2 5.28889 9.13333 4.52222 10.5167 4.52222C13.3944 4.52222 13.9222 6.41667 13.9222 8.88889V14H14Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkedIn;
